<template>
  <v-container fluid grid-list-lg class="view-container" :data-watch='watchLoader'>
    <v-layout v-if='!isLoaded' justify-center align-center fill-height>
      <loader></loader>
    </v-layout>
    <v-alert type='error' :value='true' v-if='errorMessage'>
      {{ errorMessage }}
    </v-alert>
    <v-flex xs12 v-if='isLoaded'>
      <div class='headline mb-3'>My Account</div>
      <v-card>
        <v-container fluid grid-list-lg>
          <v-layout row>
            <v-flex class='browse-card-media'>
              <v-card-media
                :src='`${$store.state.user.photo}?s=100`'
                height='100px'
                contain
              ></v-card-media>
            </v-flex>
            <v-flex>
              <div>
                <div class='headline pt-2'>{{ $store.state.user.name }}</div>
                <div>{{ $store.state.user.email }}</div>
              </div>
              <v-card-actions class='pa-0'>
                <v-spacer></v-spacer>
                <v-btn flat @click='onLogout'>Logout</v-btn>
              </v-card-actions>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-flex>
  </v-container>
</template>

<script>
  export default {

    data() {
      return {
        isLoaded: false,
        errorMessage: null
      };
    },

    computed: {
      watchLoader: {
        get() {
          if (this.isLoaded) {
            this.$store.commit('CENTER_VIEW_VERTICAL', false);
          } else {
            this.$store.commit('CENTER_VIEW_VERTICAL', true);
          }
        }
      }
    },

    methods: {
      onLogout() {
        this.$store.commit('TOKEN', null);
        this.$router.push({ name: 'Login' });
      }
    },

    created() {
      this.$store.dispatch('LOAD_USER').then(() => {
        this.isLoaded = true;
      }).catch(() => {
        this.isLoaded = true;
        this.errorMessage = 'Cannot load user information. Please contact support at support@gosnippet.com';
      });
    }
  };
</script>